import { resendOTP } from '../../../services/auth-service';
import CustomInput from '../../../components/shared/custom-input';
import Button from '../../../components/shared/custom-btn';
import React, { useState } from 'react';
import { validateForm } from '../../../utils/form-validator-utils';

const AskEmail = ({ formData, handleChange, setFormData, setStep, setErrors, errors }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    const handleEmailSubmit = async (e) => {
        e.preventDefault();
        const { errors: validationErrors, isValid } = validateForm(formData, ['email']);
        setErrors({ ...validationErrors, apiError: '' });
        setSuccessMessage('');
        if (!isValid) return;

        setIsSubmitting(true);
        try {
            const context = 'passwordReset';
            const response = await resendOTP(formData.email, context);
            console.log(response);
            if (response.success) {
                if (response.data?.data?.verificationKey) {
                    localStorage.setItem('passKeys', response.data.data.verificationKey);
                }
                setSuccessMessage(response.data.message || 'OTP sent successfully! Please check your email.');
                // setFormData(prev => ({ ...prev, email: '' }));
                setTimeout(() => {
                    setStep(2);
                }, 2000);
            } else {
                setErrors(prev => ({
                    ...prev,
                    apiError: response.data.message || 'Failed to resend OTP. Please try again.'
                }));
            }
        } catch (error) {
            setErrors(prev => ({
                ...prev,
                apiError: error.message || 'An unexpected error occurred.'
            }));
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="flex flex-col gap-4 w-full">
            {/* <div className="flex flex-col  gap-4">
                <div className=" md:text-3xl sm:text-2xl text-xl font-semibold">
                    Forgot Password
                </div>
                <div className="text-text sm:text-base text-sm">
                    No worries! Enter your email address below and we will send you
                    a code to reset password.
                </div>
            </div> */}

            {successMessage && (
                <div
                    className="mb-2 p-3 bg-green-100 text-green-700 text-sm rounded-lg text-center"
                    role="alert"
                >
                    {successMessage}
                </div>
            )}

            {errors.apiError && (
                <div
                    className="mb-2 p-3 bg-red-100 text-red-700 text-sm rounded-lg text-center"
                    role="alert"
                >
                    {errors.apiError}
                </div>
            )}

            <form onSubmit={handleEmailSubmit} className="space-y-4">
                <CustomInput
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    inputStyle="border border-border !py-2 bg-white rounded-lg"
                    placeholder="example@email.com"
                    type="email"
                    error={errors.email}
                />
                <Button
                    type="submit"
                    label={isSubmitting ? 'Sending...' : 'Send OTP'}
                    loading={isSubmitting}
                    disabled={isSubmitting}
                    className={`w-full bg-blue-800 mt-5 text-white font-medium py-2 px-4 rounded-lg ${isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-900'}`}
                />
            </form>
        </div>
    );
};

export default AskEmail;